module.exports = __webpack_public_path__ + "static/media/Refresh.b151c302.svg";